import React from "react";
import UserScreenWindow from "../User/Components/UserScreenWindow";
import GatePassDetailsPage from "../Dashboard/Security/GatePassDetailsPage";
import { useLocation } from "react-router-dom";

function SecurityGatePassDetails() {
  const location = useLocation();

  const { state } = location; // Log the gate pass ID for debugging
  return (
    <UserScreenWindow label="Gate Pass Details" backButton={true}>
      <div>
        <div>
            <GatePassDetailsPage data={state.gatePass} />
            </div>
      </div>
    </UserScreenWindow>
  );
}

export default SecurityGatePassDetails;
